import { gql } from '@apollo/client';

import type { SortingBatchStatusType } from '../../../sorting-batch/graphql/sortingBatch';

export const GET_BAG_BATCH_RECORDS = gql`
    query GetBagBatchRecords($bagNumber: String!) {
        bagBatchRecords(bagNumber: $bagNumber) {
            batchId
            batchName
            batchStatus
            warehouseId
            siteName
            joinWay
            joinedAt
            leftAt
            sourceBatchName
            nextBatchName
            waybills {
                trackingNumber
                orderId
                joinedAt
            }
        }
    }
`;

/** 加入方式：创建时加入 / 整包移入（上游批次仍保留）/ 单独移入 */
export type BagBatchJoinWay = 'CREATED' | 'MOVED_WITH_BAG' | 'MOVED_INDIVIDUALLY';

export interface BagBatchWaybillType {
    trackingNumber: string;
    /** 订单 ID（Long 以字符串形式返回），点运单号打开包裹详情用 */
    orderId: string;
    /** 计入批次的时间，epoch millis（Long 以字符串形式返回） */
    joinedAt: string;
}

/** 包牌待过的一段批次（按加入时间升序） */
export interface BagBatchRecordType {
    batchId: string;
    batchName: string;
    batchStatus: SortingBatchStatusType;
    /** 批次所属仓 id（= batch.warehouse_id）；「当前所属批次」按操作仓过滤段用 */
    warehouseId: string;
    /** 批次创建仓名 */
    siteName: string | null;
    joinWay: BagBatchJoinWay;
    /** epoch millis（Long 以字符串形式返回） */
    joinedAt: string;
    /** 仍在本批次为 null */
    leftAt: string | null;
    sourceBatchName: string | null;
    /** 离开后去往的批次；仍在本批次、或离开后不属于任何批次为 null */
    nextBatchName: string | null;
    waybills: BagBatchWaybillType[];
}

export interface GetBagBatchRecordsResponse {
    bagBatchRecords: BagBatchRecordType[];
}

export interface GetBagBatchRecordsVariables {
    bagNumber: string;
}
